module.exports = __webpack_public_path__ + "static/media/chips.04e10720.svg";